import React, { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';

import { useHandleCloseDropdownMenu } from 'hooks/useHandleCloseDropdownMenu';

import { DropdownContainer, DropdownItem, DropdownList, InputContainer, Label, Placeholder } from './styles';
import { PromoIcon } from '../PromoIcon/PromoIcon';
import { PromoText } from '../PromoText/PromoText';

export const Dropdown = (props) => {
    const wrapperRef = useRef(null);
    const [isOpenDropdownMenu, setOpenDropdownMenu] = useHandleCloseDropdownMenu(wrapperRef);
    const [placeholder, setPlaceholder] = useState(props.placeholder);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        if (props.selectedCategory !== 'all-articles') {
            const data = props.listItems.filter((item) => item.value === props.selectedCategory);
            setPlaceholder(data?.[0]?.title);
            setSelectedItem(data?.[0]?.value);
        }
    }, []);

    return (
        <DropdownContainer ref={wrapperRef}>
            {props.label && (
                <Label>
                    <PromoText variant="note" color="gray80">
                        {props.label}
                    </PromoText>
                </Label>
            )}
            <InputContainer isDisabled={props.isDisabled} onClick={() => setOpenDropdownMenu(true)}>
                <Placeholder>
                    <PromoText tag="div" color={selectedItem ? 'gray80' : 'gray40'}>
                        {placeholder}
                    </PromoText>
                </Placeholder>
                <PromoIcon name="chevron-down" color="gray80" size="24px" />
            </InputContainer>
            {isOpenDropdownMenu && (
                <DropdownList hasLabel={props.label}>
                    {props.listItems.map((item, index) => (
                        <DropdownItem isSelected={selectedItem === item.value} key={index}>
                            <PromoText tag="link" variant="link" href={`${props.link}/category/${item.value}`} color="gray80">
                                <h2>{item.title}</h2>
                            </PromoText>
                        </DropdownItem>
                    ))}
                </DropdownList>
            )}
        </DropdownContainer>
    );
};

Dropdown.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    isDisabled: PropTypes.bool,
    listItems: PropTypes.array,
};
